import React, { useContext, useEffect, useRef, useState } from 'react';
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Editing,
  Form,
  Button as GridButton,
  Toolbar,
  Item as GridItem,
  DataGridRef,
  Popup,
  Lookup,
  HeaderFilter
} from 'devextreme-react/data-grid';
import { GroupItem, Item, SimpleItem } from "devextreme-react/form";
import { dataGridErrorHandling } from '../../utils/errorHandling';
import { useOperatoriDataSource } from '../../datasources/OperatoriDataSource';
import { useEntiDataSource } from '../../datasources/EntiDataSource';
import PopupSendInvite, { SendInvitePopupHandle } from '../../components/popupSendInvite/popupSendInvite';
import { ColumnButtonClickEvent } from 'devextreme/ui/data_grid';
import OperatoreEditPopup, { OperatoreEditPopupHandle } from '../../components/operatoreEdit/OperatoreEditPopup';
import { Button } from 'devextreme-react';

export default function Operatori() {
  const dataSource = useOperatoriDataSource();
  const entiDataSource = useEntiDataSource();
  const operatoreEditPopupRef = useRef<OperatoreEditPopupHandle>(null);
  const sendInviteRef = useRef<SendInvitePopupHandle>(null);
  const gridRef = useRef<DataGridRef>(null);

  function SendInvite_click(e: ColumnButtonClickEvent) {
    sendInviteRef.current?.inviteOperatore(e.row?.key);
  }

const refreshGrid = () => { gridRef.current?.instance().refresh(); }

  function openOperatoreEditPopup(e: any) {
    operatoreEditPopupRef.current?.edit(e.row.key, `${e.row.data.nome} ${e.row.data.cognome}`);
  }

  function openOperatoreNewPopup(e: any) {
    operatoreEditPopupRef.current?.new();
  }

  return (
    <React.Fragment>
      <h2 className={'content-block'}>Operatori</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>

          <DataGrid
            dataSource={dataSource}
            onDataErrorOccurred={dataGridErrorHandling}
            ref={gridRef}
            onRowUpdating={function (e) {
              e.newData = Object.assign({}, e.oldData, e.newData);
            }}
          >
            <Editing
              mode="popup"
              allowUpdating={true}
              allowAdding={true}
              allowDeleting={true}>
              <Popup title="Operatore" showTitle={true} />
              <Form colCount={2}>
                <Item dataField="enteId" editorType='dxSelectBox' isRequired={true} colSpan={2} />
                <Item dataField="nome" editorType='dxTextBox' isRequired={true} />
                <Item dataField="cognome" editorType='dxTextBox' isRequired={true} />
                <Item dataField="codiceFiscale" editorType='dxTextBox' isRequired={false} />
                <Item dataField="regione" editorType='dxSelectBox' isRequired={false} />
                <Item dataField="provincia" editorType='dxSelectBox' isRequired={false} />
                <Item dataField="comune" editorType='dxSelectBox' isRequired={false} />

                <Item dataField="email" editorType='dxTextBox' isRequired={false} />

                <Item dataField="telefono" editorType='dxTextBox' isRequired={false} />
                <Item dataField="cellulare" editorType='dxTextBox' isRequired={false} />
                <Item dataField="userId" editorType='dxSelectBox' isRequired={false} />
              </Form>
            </Editing>
            <HeaderFilter visible={true} allowSearch={true} />
            <Column type='buttons' alignment='left'>
              <GridButton name="edit" onClick={openOperatoreEditPopup} />
              <GridButton name="delete" />
              <GridButton
                icon='send'
                hint='Invia invito a partecipare alla piattaforma'
                onClick={SendInvite_click}
                visible={(e) => e.row.data.email}
                disabled={(e)=> e.row.data.hasUserId } />
            </Column>

            <Column dataField={'id'} width={90} allowEditing={false} visible={false} />
            <Column dataField={'enteId'} caption={'Ente'} dataType='string' groupIndex={0} >
              <Lookup dataSource={entiDataSource} valueExpr="id" displayExpr="nome" />
            </Column>
            <Column dataField={'nome'} caption={'Nome'} />
            <Column dataField={'cognome'} caption={'Cognome'} />
            <Column dataField={'codiceFiscale'} caption={'Codice fiscale'} hidingPriority={1} />

            <Column dataField={'regione'} visible={false} />
            <Column dataField={'provincia'} visible={false} />
            <Column dataField={'comune'} visible={false} />

            <Column dataField={'email'} hidingPriority={2} />
            <Column dataField={'telefono'} hidingPriority={3} />
            <Column dataField={'cellulare'} hidingPriority={4} />

            <Toolbar>
              <GridItem location="after">
                <Button
                  icon='add'
                  //hint='Invia un invito per un nuovo utente'
                  stylingMode="text"
                  onClick={openOperatoreNewPopup}
                />

              </GridItem>
            </Toolbar>
          </DataGrid>


        </div>
      </div>

      <PopupSendInvite ref={sendInviteRef} />
      <OperatoreEditPopup ref={operatoreEditPopupRef} onDataChanged={refreshGrid} />
    </React.Fragment>
  )
}
